"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyToolbar = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledAppBar = (0, material_1.styled)(material_1.AppBar)(({
  theme
}) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  color: "#666666"
}));

const SskyToolbar = props => {
  return react_1.default.createElement(StyledAppBar, {
    className: props.className,
    color: props.color,
    position: props.position
  }, react_1.default.createElement(material_1.Toolbar, {
    className: props.className,
    disableGutters: props.disableGutters
  }, props.children));
};

exports.SskyToolbar = SskyToolbar;
exports.default = react_1.default.memo(SskyToolbar);